var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        "data-backdrop": _vm.backdrop,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          class: _vm.modalDialogClasses,
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                {
                  staticClass: "modal-title",
                  attrs: { id: "exampleModalLabel" }
                },
                [_vm._v(_vm._s(_vm.shownTitle))]
              ),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm._t("body", function() {
                  return [_vm._v(_vm._s(_vm.body))]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _vm._t(
                  "buttons",
                  function() {
                    return [
                      _vm._t(
                        "cancelButton",
                        function() {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { type: "button" },
                                on: { click: _vm.cancel }
                              },
                              [
                                _vm._t("cancelButtonContent", function() {
                                  return [
                                    _vm._v(_vm._s(_vm.$t("common.cancel")))
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        },
                        { close: _vm.hide }
                      ),
                      _vm._v(" "),
                      _vm._t(
                        "okButton",
                        function() {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: { click: _vm.ok }
                              },
                              [
                                _vm._t("okButtonContent", function() {
                                  return [_vm._v(_vm._s(_vm.$t("common.ok")))]
                                })
                              ],
                              2
                            )
                          ]
                        },
                        { close: _vm.hide }
                      )
                    ]
                  },
                  { close: _vm.hide }
                )
              ],
              2
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }